import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { BUArrayModel, BUModel } from "../../models/BUModel";

const initialBUState: BUArrayModel = {
  all_BUs: [],
  bus_by_SBU: [],
  particular_BU: {
    buid: 0,
    name: "",
    buuserId: 0,
    isApprovalRequired: false,
    description: "",
    isActive: false,
  },
  isBUsFetching: false,
};

const buSlice = createSlice({
  name: "BU",
  initialState: initialBUState,
  reducers: {
    setBUs(state, action: PayloadAction<BUModel[]>) {
      state.all_BUs = action.payload;
    },
    setBUsBySBU(state, action: PayloadAction<BUModel[]>) {
      state.bus_by_SBU = action.payload;
    },
    setParticularBU(state, action: PayloadAction<BUModel>) {
      state.particular_BU = action.payload;
    },
    setIsBUsFetching(state, action: PayloadAction<boolean>) {
      state.isBUsFetching = action.payload;
    },
  },
});

export default buSlice;
